import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, ModalContentAction, Typography } from 'common/components';
import { STORAGE_DESIGN_SIGN_UP_HREF, STORAGE_ELEMENT_BLOCK } from '../../../../storage-constants';

type FreeStorageProjectModalProps = {
  regionId: string;
};

export const FreeStorageProjectModal = ({ regionId }: FreeStorageProjectModalProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader title={t('utp-section.free-project.card-title')} />
      <ModalContent>
        <Typography variant="m" size="body_long">
          {t('utp-section.free-project.modal-description')}
        </Typography>
        <ModalContentAction>
          <ButtonWithGAClickButton
            adaptive={false}
            elementBlock={STORAGE_ELEMENT_BLOCK}
            elementName={t('utp-section.free-project.card-title')}
            elementText={t('design-panel.button-second')}
            href={`${STORAGE_DESIGN_SIGN_UP_HREF}${regionId}`}
            target="_blank"
            wide>
            {t('design-panel.button-second')}
          </ButtonWithGAClickButton>
        </ModalContentAction>
      </ModalContent>
    </>
  );
};
